import { render, staticRenderFns } from "./IncomeStatementSummary.vue?vue&type=template&id=88c4a256"
import script from "./IncomeStatementSummary.vue?vue&type=script&lang=js"
export * from "./IncomeStatementSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports